import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lifecycle'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'lifecycle_stages_wrapper',
          meta: {
            permissions: ['administrator', 'owner'],
          },
          redirect: to => {
            return { name: 'lifecycle_stages_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'lifecycle_stages_list',
          meta: {
            permissions: ['administrator', 'owner'],
            fullWidth: true,
          },
          component: Index,
        },
      ],
    },
  ],
};
